import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';
import { DeliveryStatus } from '../../../../../constants/status';
import api from '../../../../../api/client';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';
import { GROUP } from '../../../../../api/endpoints';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2/delivery';
const signEndpoint = apiUrl + 'v2/delivery-sign';

async function auctionApprove(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/approve`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function auctionReject(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/reject`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function addFund(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/fund/add`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function clientFundSettle(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(`${endpoint}/fund/client-settle`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getDeliveryGroups(filters) {
  const mappedFilters = { ...filters };

  if (filters.status) {
    mappedFilters.status = DeliveryStatus[filters.status];
  }

  const query = new URLSearchParams(mappedFilters).toString();
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/groups?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getDeliveryAuctions(filters) {
  const { groupId, ...otherFilters } = filters;

  const mappedFilters = { ...otherFilters };

  if (filters.status === 'all') {
    mappedFilters.status = 'all';
  } else {
    mappedFilters.status = DeliveryStatus[filters.status];
  }

  const query = new URLSearchParams(mappedFilters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/auctions/${groupId}?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

// ---- Delivery clearance signature flow (operator + winner) ----

async function startDeliveryApproval(auctionId, payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(
      `${endpoint}/${auctionId}/start-approval`,
      payload,
      config
    );
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function resendDeliverySignatureLink(auctionId) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(
      `${endpoint}/${auctionId}/resend-signature-link`,
      {},
      config
    );
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

// These two are hit from the public, unauthenticated signing page the winner
// opens via the link - no logged-in user, so no Authorization header here.

async function getDeliverySignatureByToken(token) {
  try {
    const { data: response } = await axios.get(`${signEndpoint}/${token}`);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function submitWinnerSignature(token, payload) {
  try {
    const { data: response } = await axios.post(`${signEndpoint}/${token}`, payload);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getDeliverySignatureRecord(auctionId) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/${auctionId}/signature`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function submitDeliveryCompletionApproval(auctionId, payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.post(
      `${endpoint}/${auctionId}/completion-approval`,
      payload,
      config
    );
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

export async function getDeliveryStatusDetails(params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  );
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + getLoggedUser()?.token,
    },
  };
  try {
    const { data } = await axios.get(
      `${apiUrl}v2/delivery/status-details?${new URLSearchParams(clean)}`,
      config
    );
    return data;
  } catch (error) {
    return { success: false, message: error.response?.data?.message || 'Something went wrong' };
  }
}

// export async function getGroups(params = {}) {
//   try {
//     const response = await api.get(GROUP.LIST, { params });
//     const data = handleApiResponse(response);

//     return data;
//   } catch (error) {
//     throw handleApiError(error);
//   }
// }
export {
  addFund,
  getDeliveryGroups,
  getDeliverySignatureRecord,
  submitDeliveryCompletionApproval,
  getDeliveryAuctions,
  auctionApprove,
  auctionReject,
  clientFundSettle,
  startDeliveryApproval,
  resendDeliverySignatureLink,
  getDeliverySignatureByToken,
  submitWinnerSignature,
};
